// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ICianApiSiteV1GetRegionRequest,
  TCianApiSiteV1GetRegionModel,
  IMappers,
  TCianApiSiteV1GetRegionResponse,
  ICianApiSiteV1GetRegionResponse,
  ICianApiSiteV1GetRegionResponseError,
} from './types';

export const defaultConfig: TCianApiSiteV1GetRegionModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/get-region/',
} as TCianApiSiteV1GetRegionModel;

export function createCianApiSiteV1GetRegionModel(
  parameters: ICianApiSiteV1GetRegionRequest,
): TCianApiSiteV1GetRegionModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICianApiSiteV1GetRegionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ICianApiSiteV1GetRegionRequest;
}

export async function fetchCianApiSiteV1GetRegion<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICianApiSiteV1GetRegionOptions<TResponse200, TResponse400>): Promise<
  TCianApiSiteV1GetRegionResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createCianApiSiteV1GetRegionModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICianApiSiteV1GetRegionResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ICianApiSiteV1GetRegionResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCianApiSiteV1GetRegionResponse;
}
